import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PaymentResponseDTO } from '../models/payment.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private http = inject(HttpClient);


  private baseUrl = environment.host;

  getAll(page: number, limit = 10) {
    return this.http.get<PaymentResponseDTO>(
      this.baseUrl + '/api/v1/payment?page=' + page + '&limit=' + limit
    );
  }

  approvePayment(paymentId: string) {
    return this.http.put<any>(
      this.baseUrl + '/api/v1/payment/' + paymentId + '/approve',
      {}
    );
  }
}
